<template>
	<div>
		<!--EDITAR VERSÃO-->
		<ed-modal 
			:title="(formData.id == 0 ? 'Nova Coluna' : 'Editar Coluna')+' :: '+tabela.nome" 
			:modal="showForm" 
			:loadingSave="config.loading.save"
			:onSave="salvar"
			width="99%"
		>
			<div slot="modal-content" v-loading="config.loading.content">
				<ed-form :data="formData" :config="config" :response="response" :itens="formItems">
					<div slot="form-footer" v-if="formData.id_tipo_campo == 210 || formData.id_tipo_campo == 211 || formData.id_tipo_campo == 212  || formData.id_tipo_campo == 217">
						<Valores :parent="this"/>
					</div>
				</ed-form>
			</div>
		</ed-modal>

		<ed-table
			registerName="Inserir Nova Coluna"
			:onRegister="(this.validarPermissao(571) ? onRegister: null)"
			:onEdit="onEdit"
			:onDelete="onDelete"
			:onSearch="getTabelaDinamicaColuna"
			:tableHead="tableHead"
			:tableData="tableData"
			:loadingTable="config.loading.content"
			:pagination="pagination"
			:response="response"
		/>
	</div>
</template>

<script>

	import Rest from 'common/rest'
	import EdTable from 'common/table'
	import EdForm from 'common/form'
	import EdModal from 'common/modal'
	import EdButton from 'common/button'
	import FormItems  from '../_form/tabela-coluna-cadastrar'
	import Valores from './valores'

  	export default {
  		name:"empresa",
  		components: {EdTable,EdForm,EdModal,EdButton,Valores},
		mixins:[Rest],
		props:{
            tabela:{
                type: Object,
                default: null
			},
		},
		watch:{
			'tabela.id'(){
				this.getTabelaDinamicaColuna();
			},
		},
  		data () {
		   	return {
				config:{
					tipo:[207,218],
					click:{
						id_cat:this.getTabelaDinamicaCategoria
					},
					loading:{
						content:false,
						id_cat:false,
						save:false,
					},
					list:{
						id_cat:[]
					},
				},
				response:{},
				pagination:{},
		   		tableHead:[
					{
		                key: 'id',
						sortable: true,
						width:'60px',
						label: 'Cód',
		            },
					{
		                key: 'ordem',
						sortable: true,
						width:'60px',
						label: 'Ordem',
		            },
		            {
		                key: 'nome',
						sortable: true,
						label: 'Nome',
					},
					{
		                key: 'id_tipo_campo',
						sortable: true,
						label: 'Tipo Conteúdo',
					},
					{
		                key: 'unidade',
						sortable: true,
						label: 'Unidade Medida',
					},
					{
		                key: 'valor_ref',
						sortable: true,
						label: 'Valor de Referência',
					},
					{
		                key: 'id_cat',
						sortable: true,
						label: 'Categoria',
					},
					{
		                key: 'updated_at',
						sortable: true,
						show_user:true,
						label: 'Atualização',
					},
		   		],
		   		tableData:[],
				formData:{},
				formItems:[],
				showFormEdit:false,
				showForm:false,
			}
		},

		created(){
		},

		mounted: function() {
			this.formItems = FormItems;
			this.getTabelaDinamicaColuna();
			this.getTabelaDinamicaCategoria();
		},
		methods: {
			
			onRegister(){

				this.formData = {
					id:0,
					id_tab:this.tabela.id,
					id_cat:null,
					id_tipo_campo:208,
					id_tipo_vinculo:null,
					nome:null,
					ordem:this.tableData.length+1,
					unidade:null,
					mascara:null,
					valor_ref_min:null,
					valor_ref_max:null,
					ativo:1,
					obrigatorio:0,
					ordenar:0,
					tabela_valores:[]
				};
				this.showForm = !this.showForm;
			},

			onEdit(data){
				this.formData = {
					id:data.id,
					id_tab:this.tabela.id,
					id_cat:(data.tabela_categoria ? data.tabela_categoria.id : null),
					id_tipo_campo:data.tipo_campo.id,
					id_tipo_vinculo:(data.tipo_vinculo ? data.tipo_vinculo.id : null),
					nome:data.nome,
					ordem:data.ordem,
					unidade:data.unidade,
					mascara:data.mascara,
					valor_ref_min:data.valor_ref_min,
					valor_ref_max:data.valor_ref_min,
					ativo:data.ativo,
					obrigatorio:data.obrigatorio,
					updated_at:data.updated_at,
					usuario:data.usuario,
					tabela_valores:data.tabela_valores,
					ordenar:0
				};
				this.showForm = !this.showForm;
			},

			onDelete(data){

				var self = this;
				this.response = {};

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    type: 'warning'

                }).then(() => {

                    self.config.loading.content  = true;

                    this.post('/ltcat/tabela-dinamica/coluna/'+this.tabela.id+'/deletar',{ids:data}).then((result)=>{
                        result = result[0];

						self.response = result;
                        self.config.loading.content  = false;

                        if(result.status == 200){
                            self.getTabelaDinamicaColuna();
                            self.edMsg('Registo excluido com sucesso');
                        }
                    });

                });
			},

			getTabelaDinamicaCategoria: function(_search){

				this.config.loading.id_cat = true;
				this.config.list.id_cat  = [];

				var filter = {
					ativo : 1
				}
				this.get('/ltcat/tabela-dinamica/categoria/'+this.tabela.id,{search:_search,filter:filter}).then((result)=>{

					result = result[0];

					this.config.loading.id_cat = false;

		            if(result.status == 200){
		             	this.config.list.id_cat = result.data.data;
		             }
	            });
			},

			getTabelaDinamicaColuna(_search,_page,_pagination){

				if(this.tabela.id == 0)return;

				this.config.loading.content = true;
				this.response = {};

				this.get('/ltcat/tabela-dinamica/coluna/'+this.tabela.id,{search:_search,page:_page,pagination:_pagination}).then((result)=>{
           			result = result[0];

					this.config.loading.content = false;
					this.response = result;
					this.tableData = [];

					if(result.status == 200){

		             	var
		             		data = result.data.data,
		             		tableData = [],
		             		self = this,
		             		pagination = result.data

		             	for (var i = 0; i < data.length; i++) {
							var valor_ref = '';

							if(data[i].valor_ref_min){
								valor_ref = data[i].valor_ref_min
							}

							if(data[i].valor_ref_max){
								valor_ref += (valor_ref ? ' a '+data[i].valor_ref_max : data[i].valor_ref_max);
							}

		             		var item = {
								'id': data[i].id,
								'ordem': data[i].ordem,
								'nome': data[i].nome,
								'id_tipo_campo': data[i].tipo_campo.descricao,
								'unidade': data[i].unidade,
								'id_cat': (data[i].tabela_categoria ? data[i].tabela_categoria.nome : '---'),
								'valor_ref': (valor_ref ? valor_ref : '---'),
								'updated_at': this.toDate(data[i].updated_at),
		             			_data:data[i],
		             			options:{
									style:'color:'+(data[i].ativo == 0 ? 'red' : ''),
									disable_delete:!this.validarPermissao(571),
									disable_edit:!this.validarPermissao(571),
								},
		             			buttons:[]
							 };
							 
		             		tableData.push(item);
		            	}

		             	this.pagination = pagination;
		             	this.tableData = tableData;
		            }
				});
			},

			salvar: function(){
				
				this.config.loading.save = true;
				this.response = {};

				this.post('/ltcat/tabela-dinamica/coluna/'+this.tabela.id+'/editar',this.formData).then((result)=>{

					result = result[0];
						
					this.config.loading.save = false;
					this.response = result;
					
					if(result.status == 200){
						this.edMsg('Dados atualizados')
						this.getTabelaDinamicaColuna();
						this.showForm = !this.showForm;
					}
				});
			}

		}
  	}
</script>


// WEBPACK FOOTER //
// index.vue?0c7002ac